export default [
	{
		copy: () => (
			<p>
				But how easy is it to work with the one you love? Here’s what{' '}
				<em>5,795</em> UK workers had to say about romance in the workplace.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				It turns out 2 in 3 <em>UK workers</em> are{' '}
				<strong>up for dating a colleague</strong>.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				Leaving 1 in 3 <em>workers</em> who{' '}
				<strong>would never date someone at work</strong>.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				The main reason these <em>cautious folks</em> wouldn’t date a colleague?
				They just <strong>don’t think romance and work mix</strong>.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				If you’re looking for love at work, your best bet is to apply for a job
				in the <em>leisure industry</em>. You’ll find most people are{' '}
				<strong>open to dating a colleague</strong>.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				Best to avoid <em>manufacturing</em>, though – your co-workers are
				likely to be <strong>less enthusiastic</strong>.
			</p>
		)
	},
	{
		copy: () => (
			<div>
				<p>Don’t worry if this is all news to you.</p>
				<p>
					It seems we don't like discussing our workplace romances.{' '}
					<em>Dating colleagues</em> tend to keep their relationship{' '}
					<strong>hush-hush</strong>.
				</p>
			</div>
		)
	},
	{
		copy: () => (
			<p>
				Although a noble few <em>dating colleagues</em> remain ever the
				professionals and <strong>go straight to HR</strong>.
			</p>
		)
	},
	{
		copy: () => (
			<div>
				<p>But what is it really like to date someone you work with?</p>
				<p>
					<em>Colleague couples</em> admitted feeling the need to{' '}
					<strong>act more professionally</strong>.
				</p>
			</div>
		)
	},
	{
		copy: () => (
			<p>
				<em>Colleague couples</em> also confirmed that{' '}
				<strong>gossip in the workplace</strong> added pressure to the
				relationship.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				And we found that those <em>living in London</em> were even more likely
				to feel the <strong>pressure of gossip</strong>.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				But there’s good news, too. If you’re <em>dating a colleague</em>, the
				chances are your <strong>career progression</strong> won't come into
				question.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				You won't find it any more difficult to <strong>plan holidays</strong>.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				And you'll still get that precious <strong>'me time'</strong>.
			</p>
		)
	},
	{
		copy: () => (
			<div>
				<p>
					So what's the worst that can happen when you <em>date a colleague</em>?
				</p>
				<p>
					1 in 3 feel <strong>judged</strong> by their co-workers.
				</p>
			</div>
		)
	},
	{
		copy: () => (
			<p>
				1 in 4 experience <strong>jealousy</strong>.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				1 in 6 get <strong>made fun of</strong>.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				And 1 in 10 felt they were <strong>discriminated against</strong>{' '}
				because of their workplace romance.
			</p>
		)
	},
	{
		copy: () => (
			<div>
				<p>Not everyone’s experience will be the same.</p>
				<p>
					If you're a <em>woman dating your manager</em>, your career is more
					likely to take a hit than a <em>man dating their manager</em> when it
					comes to...
				</p>
			</div>
		)
	},
	{
		copy: () => (
			<p>
				<strong>your</strong> promotion opportunities,
			</p>
		)
	},
	{
		copy: () => (
			<p>
				<strong>your</strong> salary and bonus opportunities,
			</p>
		)
	},
	{
		copy: () => (
			<p>
				<strong>your</strong> relationships with colleagues,
			</p>
		)
	},
	{
		copy: () => (
			<p>
				and <strong>your</strong> relationships with managers.
			</p>
		)
	},
	{
		copy: () => (
			<div>
				<p>Then there’s the fact that things might not (ahem) work out.</p>{' '}
				<p>
					1 in 3 <em>UK workers</em> think breaking up with a colleague would{' '}
					<strong>negatively affect workplace dynamics</strong>.
				</p>
			</div>
		)
	},
	{
		copy: () => (
			<p>
				But only 1 in 7 <em>UK workers</em> would{' '}
				<strong>quit their job</strong> because of it.
			</p>
		)
	},
	{
		copy: () => (
			<div>
				<p>A risk that seems to gradually reduce the further north you live.</p>{' '}
				<p>
					These <em>northerners</em> would <strong>quit their job</strong> if
					the relationship ended.
				</p>
			</div>
		)
	},
	{
		copy: () => (
			<p>
				Fewer than the <em>southerners</em> who would{' '}
				<strong>quit their job</strong> if the relationship ended.
			</p>
		),
		override: true
	},
	{
		copy: () => (
			<div>
				<p>
					There are plenty of reasons why a relationship at work might not last.
				</p>{' '}
				<p>
					On the <em>relationships that ended</em>, many said that{' '}
					<strong>working together killed the romance</strong>.
				</p>
			</div>
		)
	},
	{
		copy: () => (
			<p>
				Others found <strong>their relationship got in the way of work</strong>{' '}
				– and chose the latter.
			</p>
		)
	},
	{
		copy: () => (
			<p>
				But as with any relationship, sometimes{' '}
				<strong>it's just not meant to be</strong>.
			</p>
		)
	}
];



// WEBPACK FOOTER //
// ./data/sections.js